import { useQuery } from "@apollo/client";

import { type RemoteApiSpec } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { type GetSpecByIdQuery, getRemoteApiSpec } from "../api/graphql";

export const useRemoteApiSpec = (
    specId: string,
): ApolloResult<{
    spec: RemoteApiSpec | null;
}> => {
    const { data, error, loading } = useQuery<GetSpecByIdQuery>(getRemoteApiSpec, {
        variables: {
            specId,
        },
        // to support partial results
        errorPolicy: "all",
    });

    const specFromData = data?.remoteApiSpec;

    if (!specFromData) {
        return { spec: null, error, loading };
    }

    const spec = {
        ...specFromData,
        customVisibilityUserList: specFromData.customVisibilityUsersList ?? [],
    };

    return { spec, error, loading };
};
